module.exports = __webpack_public_path__ + "img/Action_plan_cards.10013cfa.webp";